<!-- 商品客户端管理 -->
<template>
    <div>
        <Panel title="责任链查询">
            <template slot="buttons">
                <el-button title="查询" class="blue" icon="el-icon-fa-search" @click="pageTable.handleLoad()">查询</el-button>
                <el-button title="重置" class="yellow" icon="el-icon-fa-refresh" @click="pageTable.handleReset()">重置</el-button>
            </template>
            <el-form :model="pageTable.param" ref="queryForm">
                <el-row>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item prop="rc_name" label="责任链名称">
                            <el-input v-model="pageTable.param.rc_name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item prop="rc_defn" label="责任链标识">
                            <el-input v-model="pageTable.param.rc_defn"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </Panel>
        <Panel title="责任链列表">
            <template slot="buttons">
                <el-button class="green" title="新增客户端" icon="el-icon-fa-plus" @click.stop="handleAddRc">添加</el-button>
                <el-button class="red" icon="el-icon-fa-trash" title="Query" @click="handleMultiDeleteRc">删除
                </el-button>
            </template>
            <el-table highlight-current-row stripe border :data="pageTable.data" v-loading="pageTable.isLoading" ref="table"
                      @selection-change="handleSelectionChange" element-loading-spinner="el-icon-loading"
                      element-loading-text="数据加载中" height="calc(100vh - 271px)">

                <el-table-column prop="$rownum" label="NO." width="50" align="center"/>
                <el-table-column type="selection" align='center' width="50"></el-table-column>
                <el-table-column prop="rcname" label="责任链名称" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="rcdefn" label="责任链标识" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="rcdesc" label="责任链描述" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button title="编辑" class="blue" @click="handleEditRc(scope.$index, scope.row)" icon="el-icon-fa-edit">编辑
                        </el-button>
                        <el-button title="删除" class="red" @click="handleDeleteRc(scope.$index, scope.row)" icon="el-icon-fa-trash">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background :page-size.sync="pageTable.size" :current-page.sync="pageTable.curr" :total="pageTable.total"/>
        </Panel>

        <el-dialog close-on-press-escape append-to-body v-draggable title="责任链编辑" :visible.sync="editor.visible" width="800px">
            <div class="dialog-button">
                <el-button title="保存责任链" class="blue" @click="handleSaveRc" v-loading="editor.loading" icon="el-icon-fa-save">保存</el-button>
            </div>
            <div v-if="editor.visible" v-loading="editor.loading">
                <RcEditor ref="RcEditorRef" v-model='editor.data' @refresh='refresh'></RcEditor>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import RcEditor from "./RcEditor.vue";
import RcApi from "./Rc";
import {PageTable} from 'cnetong-core-frontend';

export default {
    components: {RcEditor},
    data() {
        return {
            pageTable: new PageTable({
                doLoad: RcApi.queryRcList,
                autoLoad: true
            }),
            editor: {
                visible: false,
                loading: false,
                data: {}
            },
            multipleSelection: [] // 批量操作数组
        };
    },
    methods: {
        async handleSaveRc() {
            await this.confirm();
            await this.$refs.RcEditorRef.handleSaveRc();
        },
        async handleMultiDeleteRc() {
            if (this.multipleSelection.length === 0) {
                this.$message.warning("请选择数据！");
                return;
            }
            try {
                await this.confirm();
                this.pageTable.isLoading = true;
                let array = this.multipleSelection.map(v => v.uuid);
                await RcApi.delRc(array);
                this.pageTable.handleLoad();
            } finally {
                this.pageTable.isLoading = false;
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 删除责任链
        async handleDeleteRc(index, rowData) {
            try {
                await this.confirm();
                this.pageTable.isLoading = true;
                this.editor.uuid = rowData.uuid;
                await RcApi.delRc([rowData.uuid]);
                this.pageTable.handleLoad();
            } finally {
                this.pageTable.isLoading = false;
            }
        },
        refresh() {
            this.pageTable.handleLoad();
          this.editor.visible = false;
        },
        handleAddRc() {
            this.editor.data = {};
            this.editor.visible = true;
        },
        handleEditRc(index, rowData) {
            this.editor.data = rowData;
            this.editor.visible = true;
        },
    }
};
</script>
